import {
  SYSTEM_FILTER_OPTION,
  SYSTEM_VALUE,
  systemCategoryOption,
} from '../config/system.config.js'

function appendSystemOptionsIcon(options) {
  return [...options, SYSTEM_FILTER_OPTION]
}

function isSystemOption(option) {
  return option === SYSTEM_VALUE
}

function findSystemCategoryRow(items = []) {
  return items.find((row) => row.system === true) ?? null
}

function isSystemCategoryId(categoryId, items = []) {
  if (categoryId == null || categoryId === '') return false
  const row = findSystemCategoryRow(items)
  return Boolean(row?._id && String(row._id) === String(categoryId))
}

function matchesSystemCategory(categoryId, userCategoryItems = []) {
  return isSystemCategoryId(categoryId, userCategoryItems)
}

function sortSystemFirst(items = []) {
  const system = items.filter((row) => row.system === true || row.systemKey)
  const user = items.filter((row) => !row.system && !row.systemKey)
  return [...system, ...user]
}

function withSystemFallbackIcon(options, currentValue, allItems) {
  if (!isSystemCategoryId(currentValue, allItems)) return options
  const row = findSystemCategoryRow(allItems)
  if (!row) return options
  return [...options.filter((option) => String(option.value) !== String(currentValue)), systemCategoryOption(row, { icon: true })]
}

class SystemUtility {
  options = {
    /**
     * Append a synthetic "System" filter row with cpu icon.
     *
     * @param {object[]} options
     * @returns {object[]}
     */
    icon(options) {
      return appendSystemOptionsIcon(options)
    },

    /**
     * Resolve the trigger row for a bound system category id.
     *
     * @param {object[]} options
     * @param {string|null|undefined} currentValue
     * @param {object[]} allItems
     * @returns {object|null}
     */
    displayValue(options, currentValue, allItems, { icon = false } = {}) {
      if (!isSystemCategoryId(currentValue, allItems)) return null
      const row = findSystemCategoryRow(allItems)
      if (!row) return null
      return systemCategoryOption(row, { icon })
    },

    /**
     * Append a synthetic system row when the bound id is the system category.
     *
     * @param {object[]} options
     * @param {string|null|undefined} currentValue
     * @param {object[]} allItems
     * @returns {object[]}
     */
    withFallbackIcon(options, currentValue, allItems) {
      return withSystemFallbackIcon(options, currentValue, allItems)
    },
  }

  /**
   * Whether `option` is the synthetic system filter sentinel.
   *
   * @param {string} option
   * @returns {boolean}
   */
  is(option) {
    return isSystemOption(option)
  }

  /**
   * Whether `categoryId` refers to the system category row on a settings host.
   *
   * @param {string|null|undefined} categoryId
   * @param {object[]} items
   * @returns {boolean}
   */
  matches(categoryId, items) {
    return matchesSystemCategory(categoryId, items)
  }

  /**
   * @param {object[]} items
   * @returns {object|null}
   */
  findRow(items) {
    return findSystemCategoryRow(items)
  }

  /**
   * Settings list ordering — system rows first.
   *
   * @param {object[]} items
   * @returns {object[]}
   */
  sortFirst(items) {
    return sortSystemFirst(items)
  }
}

export default new SystemUtility()
